import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import MainPage from './components/MainPage';
import Recintos from './components/Recintos';
import Proveedores from './components/Proveedores';
import Escaneos from './components/Escaneos';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import './App.css';
import Eventos from './components/Eventos';
import Etiqueta from './components/Etiqueta';
import Etiquetas from './components/Etiquetas';
import NotFound from './components/NotFound';
import EventoProveedores from './components/EventoProveedores';
import Codigo from './components/Codigo';
import Codigos from './components/Codigos';
import EscaneosEvento from './components/EscaneosEvento';
import EstadisticasEvento from './components/EstadisticasEvento';

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    !!localStorage.getItem('token')
  );

  const handleLoginSuccess = () => 
  {
    setIsAuthenticated(true);
  };

  const handleLogout = () => 
  {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
  };

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login onLoginSuccess={handleLoginSuccess} />} />
          
          <Route
            path="/main"
            element={<PrivateRoute element={<MainPage onLogout={handleLogout} />} isAuthenticated={isAuthenticated} />}
          >
            <Route path="recintos" element={<Recintos />} />
            <Route path="recintos/:clientId/eventos" element={<Eventos />} />
            <Route path="recintos/:clientId/eventos/:eventId/tags" element={<Etiquetas />} />
            <Route path="recintos/:clientId/eventos/:eventId/providers" element={<EventoProveedores />} />
            <Route path="recintos/:clientId/eventos/:eventId/codes" element={<Codigos />} />
            <Route path="recintos/:clientId/eventos/:eventId/scans" element={<EscaneosEvento />} />
            <Route path="recintos/:clientId/eventos/:eventId/statistics" element={<EstadisticasEvento />} />
            <Route path="proveedores" element={<Proveedores />} />
            <Route path="escaneos" element={<Escaneos />} />
            <Route path="*" element={<NotFound />} />  {/* dentro de main, con header */}
          </Route>

          <Route path="*" element={<NotFound />} />  {/* fuera de main, sin header */}
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
